import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Users, FolderTree, BookOpen, DollarSign } from 'lucide-react';
import { useAdminStats } from '@/presentation/hook/useAdminStats';
import { KpiCard, Alert } from '@/presentation/component/ui';
import { formatCFA } from '@/presentation/util/format';

export const AdminDashboardPage = () => {
  const { t } = useTranslation();
  const { stats, isLoading, error, fetchStats, clearError } = useAdminStats();

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  return (
    <div>
      <h1 className="text-2xl font-bold text-[var(--color-ink)]">{t('admin.dashboard')}</h1>

      {error && (
        <Alert kind="bad" onClose={clearError} className="mt-4">
          {t(error)}
        </Alert>
      )}

      {isLoading && (
        <p className="mt-6 text-center text-[var(--color-ink-faint)]">{t('common.loading')}</p>
      )}

      {!isLoading && !stats && !error && (
        <p className="mt-6 text-center text-[var(--color-ink-faint)]">{t('admin.noStats')}</p>
      )}

      {stats && (
        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
          <KpiCard
            label={t('admin.totalUsers')}
            value={stats.totalUsers}
            icon={<Users className="h-5 w-5" />}
          />
          <KpiCard
            label={t('admin.totalCategories')}
            value={stats.totalCategories}
            icon={<FolderTree className="h-5 w-5" />}
          />
          <KpiCard
            label={t('admin.totalSubcategories')}
            value={stats.totalSubcategories}
            icon={<FolderTree className="h-5 w-5" />}
          />
          <KpiCard
            label={t('admin.totalCourses')}
            value={stats.totalCourses}
            icon={<BookOpen className="h-5 w-5" />}
          />
          <KpiCard
            label={t('admin.totalRevenue')}
            value={formatCFA(stats.totalRevenue)}
            icon={<DollarSign className="h-5 w-5" />}
          />
        </div>
      )}
    </div>
  );
};
